export default __webpack_public_path__ + "static/media/velan-sir-img.57db269a.jpeg";